/**
 * Generated by @openapi-codegen
 *
 * @version 2.3.4
 */
import * as reactQuery from '@tanstack/react-query';
import { useNoteGoApiContext, NoteGoApiContext } from './noteGoApiContext';
import type * as Fetcher from './noteGoApiFetcher';
import { noteGoApiFetch } from './noteGoApiFetcher';
import type * as Schemas from './noteGoApiSchemas';

export type RootGetError = Fetcher.ErrorWrapper<undefined>;

export type RootGetResponse = {
  [key: string]: string;
};

export type RootGetVariables = NoteGoApiContext['fetcherOptions'];

export const fetchRootGet = (variables: RootGetVariables, signal?: AbortSignal) =>
  noteGoApiFetch<RootGetResponse, RootGetError, undefined, {}, {}, {}>({
    url: '/',
    method: 'get',
    ...variables,
    signal,
  });

export const useRootGet = <TData = RootGetResponse>(
  variables: RootGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<RootGetResponse, RootGetError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useNoteGoApiContext(options);
  return reactQuery.useQuery<RootGetResponse, RootGetError, TData>({
    queryKey: queryKeyFn({ path: '/', operationId: 'rootGet', variables }),
    queryFn: ({ signal }) => fetchRootGet({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type TestTestGetError = Fetcher.ErrorWrapper<undefined>;

export type TestTestGetResponse = {
  [key: string]: string;
};

export type TestTestGetVariables = NoteGoApiContext['fetcherOptions'];

export const fetchTestTestGet = (variables: TestTestGetVariables, signal?: AbortSignal) =>
  noteGoApiFetch<TestTestGetResponse, TestTestGetError, undefined, {}, {}, {}>({
    url: '/test',
    method: 'get',
    ...variables,
    signal,
  });

export const useTestTestGet = <TData = TestTestGetResponse>(
  variables: TestTestGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<TestTestGetResponse, TestTestGetError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useNoteGoApiContext(options);
  return reactQuery.useQuery<TestTestGetResponse, TestTestGetError, TData>({
    queryKey: queryKeyFn({
      path: '/test',
      operationId: 'testTestGet',
      variables,
    }),
    queryFn: ({ signal }) => fetchTestTestGet({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type HealthcheckHealthzGetError = Fetcher.ErrorWrapper<undefined>;

export type HealthcheckHealthzGetResponse = {
  [key: string]: string;
};

export type HealthcheckHealthzGetVariables = NoteGoApiContext['fetcherOptions'];

export const fetchHealthcheckHealthzGet = (variables: HealthcheckHealthzGetVariables, signal?: AbortSignal) =>
  noteGoApiFetch<HealthcheckHealthzGetResponse, HealthcheckHealthzGetError, undefined, {}, {}, {}>({
    url: '/healthz',
    method: 'get',
    ...variables,
    signal,
  });

export const useHealthcheckHealthzGet = <TData = HealthcheckHealthzGetResponse>(
  variables: HealthcheckHealthzGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<HealthcheckHealthzGetResponse, HealthcheckHealthzGetError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useNoteGoApiContext(options);
  return reactQuery.useQuery<HealthcheckHealthzGetResponse, HealthcheckHealthzGetError, TData>({
    queryKey: queryKeyFn({
      path: '/healthz',
      operationId: 'healthcheckHealthzGet',
      variables,
    }),
    queryFn: ({ signal }) => fetchHealthcheckHealthzGet({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type GetSharedNotePathParams = {
  token: string;
};

export type GetSharedNoteError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type GetSharedNoteVariables = {
  pathParams: GetSharedNotePathParams;
} & NoteGoApiContext['fetcherOptions'];

/**
 * Retrieve a publicly shared note by its token. No authentication required.
 */
export const fetchGetSharedNote = (variables: GetSharedNoteVariables, signal?: AbortSignal) =>
  noteGoApiFetch<Schemas.NoteOut, GetSharedNoteError, undefined, {}, {}, GetSharedNotePathParams>({
    url: '/shared/{token}',
    method: 'get',
    ...variables,
    signal,
  });

/**
 * Retrieve a publicly shared note by its token. No authentication required.
 */
export const useGetSharedNote = <TData = Schemas.NoteOut>(
  variables: GetSharedNoteVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.NoteOut, GetSharedNoteError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useNoteGoApiContext(options);
  return reactQuery.useQuery<Schemas.NoteOut, GetSharedNoteError, TData>({
    queryKey: queryKeyFn({
      path: '/shared/{token}',
      operationId: 'getSharedNote',
      variables,
    }),
    queryFn: ({ signal }) => fetchGetSharedNote({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type GetNotePathParams = {
  noteId: string;
};

export type GetNoteHeaders = {
  authorization: string;
};

export type GetNoteError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type GetNoteVariables = {
  headers: GetNoteHeaders;
  pathParams: GetNotePathParams;
} & NoteGoApiContext['fetcherOptions'];

export const fetchGetNote = (variables: GetNoteVariables, signal?: AbortSignal) =>
  noteGoApiFetch<Schemas.NoteOut, GetNoteError, undefined, GetNoteHeaders, {}, GetNotePathParams>({
    url: '/notes/{noteId}',
    method: 'get',
    ...variables,
    signal,
  });

export const useGetNote = <TData = Schemas.NoteOut>(
  variables: GetNoteVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.NoteOut, GetNoteError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useNoteGoApiContext(options);
  return reactQuery.useQuery<Schemas.NoteOut, GetNoteError, TData>({
    queryKey: queryKeyFn({
      path: '/notes/{noteId}',
      operationId: 'getNote',
      variables,
    }),
    queryFn: ({ signal }) => fetchGetNote({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type UpdateNotePathParams = {
  noteId: string;
};

export type UpdateNoteHeaders = {
  authorization: string;
};

export type UpdateNoteError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type UpdateNoteVariables = {
  body?: Schemas.NoteUpdate;
  headers: UpdateNoteHeaders;
  pathParams: UpdateNotePathParams;
} & NoteGoApiContext['fetcherOptions'];

export const fetchUpdateNote = (variables: UpdateNoteVariables, signal?: AbortSignal) =>
  noteGoApiFetch<Schemas.NoteOut, UpdateNoteError, Schemas.NoteUpdate, UpdateNoteHeaders, {}, UpdateNotePathParams>({
    url: '/notes/{noteId}',
    method: 'put',
    ...variables,
    signal,
  });

export const useUpdateNote = (
  options?: Omit<reactQuery.UseMutationOptions<Schemas.NoteOut, UpdateNoteError, UpdateNoteVariables>, 'mutationFn'>,
) => {
  const { fetcherOptions } = useNoteGoApiContext();
  return reactQuery.useMutation<Schemas.NoteOut, UpdateNoteError, UpdateNoteVariables>({
    mutationFn: (variables: UpdateNoteVariables) => fetchUpdateNote({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type DeleteNotePathParams = {
  noteId: string;
};

export type DeleteNoteHeaders = {
  authorization: string;
};

export type DeleteNoteError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type DeleteNoteVariables = {
  headers: DeleteNoteHeaders;
  pathParams: DeleteNotePathParams;
} & NoteGoApiContext['fetcherOptions'];

export const fetchDeleteNote = (variables: DeleteNoteVariables, signal?: AbortSignal) =>
  noteGoApiFetch<undefined, DeleteNoteError, undefined, DeleteNoteHeaders, {}, DeleteNotePathParams>({
    url: '/notes/{noteId}',
    method: 'delete',
    ...variables,
    signal,
  });

export const useDeleteNote = (
  options?: Omit<reactQuery.UseMutationOptions<undefined, DeleteNoteError, DeleteNoteVariables>, 'mutationFn'>,
) => {
  const { fetcherOptions } = useNoteGoApiContext();
  return reactQuery.useMutation<undefined, DeleteNoteError, DeleteNoteVariables>({
    mutationFn: (variables: DeleteNoteVariables) => fetchDeleteNote({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetAllNotesQueryParams = {
  /**
   * @default 10
   */
  limit?: number | null;
  cursor?: string | null;
  favorite?: boolean | null;
};

export type GetAllNotesHeaders = {
  authorization: string;
};

export type GetAllNotesError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type GetAllNotesResponse = {
  [key: string]: any;
};

export type GetAllNotesVariables = {
  headers: GetAllNotesHeaders;
  queryParams?: GetAllNotesQueryParams;
} & NoteGoApiContext['fetcherOptions'];

export const fetchGetAllNotes = (variables: GetAllNotesVariables, signal?: AbortSignal) =>
  noteGoApiFetch<GetAllNotesResponse, GetAllNotesError, undefined, GetAllNotesHeaders, GetAllNotesQueryParams, {}>({
    url: '/notes/',
    method: 'get',
    ...variables,
    signal,
  });

export const useGetAllNotes = <TData = GetAllNotesResponse>(
  variables: GetAllNotesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<GetAllNotesResponse, GetAllNotesError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useNoteGoApiContext(options);
  return reactQuery.useQuery<GetAllNotesResponse, GetAllNotesError, TData>({
    queryKey: queryKeyFn({
      path: '/notes/',
      operationId: 'getAllNotes',
      variables,
    }),
    queryFn: ({ signal }) => fetchGetAllNotes({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type CreateNoteHeaders = {
  authorization: string;
};

export type CreateNoteError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type CreateNoteVariables = {
  headers: CreateNoteHeaders;
} & NoteGoApiContext['fetcherOptions'];

export const fetchCreateNote = (variables: CreateNoteVariables, signal?: AbortSignal) =>
  noteGoApiFetch<Schemas.NoteOut, CreateNoteError, undefined, CreateNoteHeaders, {}, {}>({
    url: '/notes/',
    method: 'post',
    ...variables,
    signal,
  });

export const useCreateNote = (
  options?: Omit<reactQuery.UseMutationOptions<Schemas.NoteOut, CreateNoteError, CreateNoteVariables>, 'mutationFn'>,
) => {
  const { fetcherOptions } = useNoteGoApiContext();
  return reactQuery.useMutation<Schemas.NoteOut, CreateNoteError, CreateNoteVariables>({
    mutationFn: (variables: CreateNoteVariables) => fetchCreateNote({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type SearchNotesQueryParams = {
  favorite?: boolean | null;
  keywords?: string | null;
  /**
   * @default 20
   */
  limit?: number | null;
  cursor?: string | null;
  sort_by?: Schemas.SortByEnum | null;
  /**
   * @default asc
   */
  sort_order?: Schemas.SortOrderEnum | null;
  processing_type?: Schemas.ProcessingTypeEnum | null;
  tags?: string | null;
  shared?: boolean | null;
  created_after?: string | null;
};

export type SearchNotesHeaders = {
  authorization: string;
};

export type SearchNotesError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type SearchNotesResponse = {
  [key: string]: any;
};

export type SearchNotesVariables = {
  headers: SearchNotesHeaders;
  queryParams?: SearchNotesQueryParams;
} & NoteGoApiContext['fetcherOptions'];

/**
 * Search notes by keywords in title, summary, or transcript with optional pagination.
 */
export const fetchSearchNotes = (variables: SearchNotesVariables, signal?: AbortSignal) =>
  noteGoApiFetch<SearchNotesResponse, SearchNotesError, undefined, SearchNotesHeaders, SearchNotesQueryParams, {}>({
    url: '/notes/search/',
    method: 'get',
    ...variables,
    signal,
  });

/**
 * Search notes by keywords in title, summary, or transcript with optional pagination.
 */
export const useSearchNotes = <TData = SearchNotesResponse>(
  variables: SearchNotesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<SearchNotesResponse, SearchNotesError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useNoteGoApiContext(options);
  return reactQuery.useQuery<SearchNotesResponse, SearchNotesError, TData>({
    queryKey: queryKeyFn({
      path: '/notes/search/',
      operationId: 'searchNotes',
      variables,
    }),
    queryFn: ({ signal }) => fetchSearchNotes({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type GetMyNotesDirectQueryParams = {
  /**
   * Number of notes to return (ignored; all notes returned)
   */
  limit?: number | null;
  /**
   * Pagination cursor (ignored; all notes returned)
   */
  cursor?: string | null;
  /**
   * Comma-separated list of tags to filter by
   */
  tags?: string | null;
  /**
   * Keywords to search for
   */
  keywords?: string | null;
  /**
   * Filter by processing type
   */
  processing_type?: string | null;
  /**
   * Filter by favorite status
   */
  favorite?: boolean | null;
  /**
   * Field to sort by
   *
   * @default created_at
   */
  sort_by?: string | null;
  /**
   * Sort order (asc or desc)
   *
   * @default desc
   */
  sort_order?: string | null;
};

export type GetMyNotesDirectHeaders = {
  authorization: string;
};

export type GetMyNotesDirectError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type GetMyNotesDirectResponse = {
  [key: string]: any;
};

export type GetMyNotesDirectVariables = {
  headers: GetMyNotesDirectHeaders;
  queryParams?: GetMyNotesDirectQueryParams;
} & NoteGoApiContext['fetcherOptions'];

/**
 * Get notes owned by the current user directly from notes collection.
 * This avoids the complexity of the user_notes join table.
 */
export const fetchGetMyNotesDirect = (variables: GetMyNotesDirectVariables, signal?: AbortSignal) =>
  noteGoApiFetch<
    GetMyNotesDirectResponse,
    GetMyNotesDirectError,
    undefined,
    GetMyNotesDirectHeaders,
    GetMyNotesDirectQueryParams,
    {}
  >({ url: '/notes/my-notes/', method: 'get', ...variables, signal });

/**
 * Get notes owned by the current user directly from notes collection.
 * This avoids the complexity of the user_notes join table.
 */
export const useGetMyNotesDirect = <TData = GetMyNotesDirectResponse>(
  variables: GetMyNotesDirectVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<GetMyNotesDirectResponse, GetMyNotesDirectError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useNoteGoApiContext(options);
  return reactQuery.useQuery<GetMyNotesDirectResponse, GetMyNotesDirectError, TData>({
    queryKey: queryKeyFn({
      path: '/notes/my-notes/',
      operationId: 'getMyNotesDirect',
      variables,
    }),
    queryFn: ({ signal }) => fetchGetMyNotesDirect({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type CreatePublicSharePathParams = {
  noteId: string;
};

export type CreatePublicShareHeaders = {
  authorization: string;
};

export type CreatePublicShareError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type CreatePublicShareVariables = {
  body?: Schemas.PublicShareRequest;
  headers: CreatePublicShareHeaders;
  pathParams: CreatePublicSharePathParams;
} & NoteGoApiContext['fetcherOptions'];

/**
 * Create a public share link for a note. Returns the share token and expiry.
 */
export const fetchCreatePublicShare = (variables: CreatePublicShareVariables, signal?: AbortSignal) =>
  noteGoApiFetch<
    Schemas.PublicShareResponse,
    CreatePublicShareError,
    Schemas.PublicShareRequest,
    CreatePublicShareHeaders,
    {},
    CreatePublicSharePathParams
  >({
    url: '/notes/{noteId}/share_public',
    method: 'post',
    ...variables,
    signal,
  });

/**
 * Create a public share link for a note. Returns the share token and expiry.
 */
export const useCreatePublicShare = (
  options?: Omit<
    reactQuery.UseMutationOptions<Schemas.PublicShareResponse, CreatePublicShareError, CreatePublicShareVariables>,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useNoteGoApiContext();
  return reactQuery.useMutation<Schemas.PublicShareResponse, CreatePublicShareError, CreatePublicShareVariables>({
    mutationFn: (variables: CreatePublicShareVariables) => fetchCreatePublicShare({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type InviteToNoteHeaders = {
  authorization: string;
};

export type InviteToNoteError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type InviteToNoteResponse = {
  [key: string]: string;
};

export type InviteToNoteVariables = {
  body: Schemas.InviteRequest;
  headers: InviteToNoteHeaders;
} & NoteGoApiContext['fetcherOptions'];

/**
 * Endpoint to invite users to a note.
 */
export const fetchInviteToNote = (variables: InviteToNoteVariables, signal?: AbortSignal) =>
  noteGoApiFetch<InviteToNoteResponse, InviteToNoteError, Schemas.InviteRequest, InviteToNoteHeaders, {}, {}>({
    url: '/notes/invite',
    method: 'post',
    ...variables,
    signal,
  });

/**
 * Endpoint to invite users to a note.
 */
export const useInviteToNote = (
  options?: Omit<
    reactQuery.UseMutationOptions<InviteToNoteResponse, InviteToNoteError, InviteToNoteVariables>,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useNoteGoApiContext();
  return reactQuery.useMutation<InviteToNoteResponse, InviteToNoteError, InviteToNoteVariables>({
    mutationFn: (variables: InviteToNoteVariables) => fetchInviteToNote({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ToggleFavoritePathParams = {
  noteId: string;
};

export type ToggleFavoriteHeaders = {
  authorization: string;
};

export type ToggleFavoriteError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type ToggleFavoriteVariables = {
  body: Schemas.ToggleFavoriteRequest;
  headers: ToggleFavoriteHeaders;
  pathParams: ToggleFavoritePathParams;
} & NoteGoApiContext['fetcherOptions'];

/**
 * Toggle the favorite status of a note for the current user.
 */
export const fetchToggleFavorite = (variables: ToggleFavoriteVariables, signal?: AbortSignal) =>
  noteGoApiFetch<
    Schemas.NoteOut,
    ToggleFavoriteError,
    Schemas.ToggleFavoriteRequest,
    ToggleFavoriteHeaders,
    {},
    ToggleFavoritePathParams
  >({ url: '/notes/{noteId}/favorite', method: 'patch', ...variables, signal });

/**
 * Toggle the favorite status of a note for the current user.
 */
export const useToggleFavorite = (
  options?: Omit<
    reactQuery.UseMutationOptions<Schemas.NoteOut, ToggleFavoriteError, ToggleFavoriteVariables>,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useNoteGoApiContext();
  return reactQuery.useMutation<Schemas.NoteOut, ToggleFavoriteError, ToggleFavoriteVariables>({
    mutationFn: (variables: ToggleFavoriteVariables) => fetchToggleFavorite({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetUserHeaders = {
  authorization: string;
};

export type GetUserError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type GetUserVariables = {
  headers: GetUserHeaders;
} & NoteGoApiContext['fetcherOptions'];

export const fetchGetUser = (variables: GetUserVariables, signal?: AbortSignal) =>
  noteGoApiFetch<Schemas.UserOut, GetUserError, undefined, GetUserHeaders, {}, {}>({
    url: '/users/me',
    method: 'get',
    ...variables,
    signal,
  });

export const useGetUser = <TData = Schemas.UserOut>(
  variables: GetUserVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.UserOut, GetUserError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useNoteGoApiContext(options);
  return reactQuery.useQuery<Schemas.UserOut, GetUserError, TData>({
    queryKey: queryKeyFn({
      path: '/users/me',
      operationId: 'getUser',
      variables,
    }),
    queryFn: ({ signal }) => fetchGetUser({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type GetUsersByIdsQueryParams = {
  ids: string[];
};

export type GetUsersByIdsHeaders = {
  authorization: string;
};

export type GetUsersByIdsError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type GetUsersByIdsResponse = Schemas.UserOut[];

export type GetUsersByIdsVariables = {
  headers: GetUsersByIdsHeaders;
  queryParams: GetUsersByIdsQueryParams;
} & NoteGoApiContext['fetcherOptions'];

export const fetchGetUsersByIds = (variables: GetUsersByIdsVariables, signal?: AbortSignal) =>
  noteGoApiFetch<
    GetUsersByIdsResponse,
    GetUsersByIdsError,
    undefined,
    GetUsersByIdsHeaders,
    GetUsersByIdsQueryParams,
    {}
  >({ url: '/users/', method: 'get', ...variables, signal });

export const useGetUsersByIds = <TData = GetUsersByIdsResponse>(
  variables: GetUsersByIdsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<GetUsersByIdsResponse, GetUsersByIdsError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useNoteGoApiContext(options);
  return reactQuery.useQuery<GetUsersByIdsResponse, GetUsersByIdsError, TData>({
    queryKey: queryKeyFn({
      path: '/users/',
      operationId: 'getUsersByIds',
      variables,
    }),
    queryFn: ({ signal }) => fetchGetUsersByIds({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type CreateUserHeaders = {
  authorization: string;
};

export type CreateUserError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type CreateUserVariables = {
  body?: Schemas.UserCreate;
  headers: CreateUserHeaders;
} & NoteGoApiContext['fetcherOptions'];

export const fetchCreateUser = (variables: CreateUserVariables, signal?: AbortSignal) =>
  noteGoApiFetch<Schemas.UserOut, CreateUserError, Schemas.UserCreate, CreateUserHeaders, {}, {}>({
    url: '/users/',
    method: 'post',
    ...variables,
    signal,
  });

export const useCreateUser = (
  options?: Omit<reactQuery.UseMutationOptions<Schemas.UserOut, CreateUserError, CreateUserVariables>, 'mutationFn'>,
) => {
  const { fetcherOptions } = useNoteGoApiContext();
  return reactQuery.useMutation<Schemas.UserOut, CreateUserError, CreateUserVariables>({
    mutationFn: (variables: CreateUserVariables) => fetchCreateUser({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type DeleteUserHeaders = {
  authorization: string;
};

export type DeleteUserError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type DeleteUserVariables = {
  headers: DeleteUserHeaders;
} & NoteGoApiContext['fetcherOptions'];

export const fetchDeleteUser = (variables: DeleteUserVariables, signal?: AbortSignal) =>
  noteGoApiFetch<undefined, DeleteUserError, undefined, DeleteUserHeaders, {}, {}>({
    url: '/users/',
    method: 'delete',
    ...variables,
    signal,
  });

export const useDeleteUser = (
  options?: Omit<reactQuery.UseMutationOptions<undefined, DeleteUserError, DeleteUserVariables>, 'mutationFn'>,
) => {
  const { fetcherOptions } = useNoteGoApiContext();
  return reactQuery.useMutation<undefined, DeleteUserError, DeleteUserVariables>({
    mutationFn: (variables: DeleteUserVariables) => fetchDeleteUser({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type UpdateUserPathParams = {
  userId: string;
};

export type UpdateUserHeaders = {
  authorization: string;
};

export type UpdateUserError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type UpdateUserVariables = {
  body?: Schemas.UserUpdate;
  headers: UpdateUserHeaders;
  pathParams: UpdateUserPathParams;
} & NoteGoApiContext['fetcherOptions'];

export const fetchUpdateUser = (variables: UpdateUserVariables, signal?: AbortSignal) =>
  noteGoApiFetch<Schemas.UserOut, UpdateUserError, Schemas.UserUpdate, UpdateUserHeaders, {}, UpdateUserPathParams>({
    url: '/users/{userId}',
    method: 'put',
    ...variables,
    signal,
  });

export const useUpdateUser = (
  options?: Omit<reactQuery.UseMutationOptions<Schemas.UserOut, UpdateUserError, UpdateUserVariables>, 'mutationFn'>,
) => {
  const { fetcherOptions } = useNoteGoApiContext();
  return reactQuery.useMutation<Schemas.UserOut, UpdateUserError, UpdateUserVariables>({
    mutationFn: (variables: UpdateUserVariables) => fetchUpdateUser({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type UpdateEmailHeaders = {
  authorization: string;
};

export type UpdateEmailError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type UpdateEmailVariables = {
  body: Schemas.UpdateEmailBody;
  headers: UpdateEmailHeaders;
} & NoteGoApiContext['fetcherOptions'];

export const fetchUpdateEmail = (variables: UpdateEmailVariables, signal?: AbortSignal) =>
  noteGoApiFetch<undefined, UpdateEmailError, Schemas.UpdateEmailBody, UpdateEmailHeaders, {}, {}>({
    url: '/users/update_email',
    method: 'post',
    ...variables,
    signal,
  });

export const useUpdateEmail = (
  options?: Omit<reactQuery.UseMutationOptions<undefined, UpdateEmailError, UpdateEmailVariables>, 'mutationFn'>,
) => {
  const { fetcherOptions } = useNoteGoApiContext();
  return reactQuery.useMutation<undefined, UpdateEmailError, UpdateEmailVariables>({
    mutationFn: (variables: UpdateEmailVariables) => fetchUpdateEmail({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type CleanupUserDuplicatesHeaders = {
  authorization: string;
};

export type CleanupUserDuplicatesError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type CleanupUserDuplicatesVariables = {
  headers: CleanupUserDuplicatesHeaders;
} & NoteGoApiContext['fetcherOptions'];

/**
 * Administrative endpoint to find and merge duplicate user documents for the authenticated user.
 * This endpoint can be used to clean up existing duplicates created by race conditions.
 */
export const fetchCleanupUserDuplicates = (variables: CleanupUserDuplicatesVariables, signal?: AbortSignal) =>
  noteGoApiFetch<Schemas.UserOut, CleanupUserDuplicatesError, undefined, CleanupUserDuplicatesHeaders, {}, {}>({
    url: '/users/cleanup_duplicates',
    method: 'post',
    ...variables,
    signal,
  });

/**
 * Administrative endpoint to find and merge duplicate user documents for the authenticated user.
 * This endpoint can be used to clean up existing duplicates created by race conditions.
 */
export const useCleanupUserDuplicates = (
  options?: Omit<
    reactQuery.UseMutationOptions<Schemas.UserOut, CleanupUserDuplicatesError, CleanupUserDuplicatesVariables>,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useNoteGoApiContext();
  return reactQuery.useMutation<Schemas.UserOut, CleanupUserDuplicatesError, CleanupUserDuplicatesVariables>({
    mutationFn: (variables: CleanupUserDuplicatesVariables) =>
      fetchCleanupUserDuplicates({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type CheckUserDuplicatesHeaders = {
  authorization: string;
};

export type CheckUserDuplicatesError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type CheckUserDuplicatesResponse = {
  [key: string]: any;
};

export type CheckUserDuplicatesVariables = {
  headers: CheckUserDuplicatesHeaders;
} & NoteGoApiContext['fetcherOptions'];

/**
 * Check if the authenticated user has duplicate documents in Firestore.
 * Returns information about found duplicates without modifying anything.
 */
export const fetchCheckUserDuplicates = (variables: CheckUserDuplicatesVariables, signal?: AbortSignal) =>
  noteGoApiFetch<CheckUserDuplicatesResponse, CheckUserDuplicatesError, undefined, CheckUserDuplicatesHeaders, {}, {}>({
    url: '/users/check_duplicates',
    method: 'get',
    ...variables,
    signal,
  });

/**
 * Check if the authenticated user has duplicate documents in Firestore.
 * Returns information about found duplicates without modifying anything.
 */
export const useCheckUserDuplicates = <TData = CheckUserDuplicatesResponse>(
  variables: CheckUserDuplicatesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<CheckUserDuplicatesResponse, CheckUserDuplicatesError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useNoteGoApiContext(options);
  return reactQuery.useQuery<CheckUserDuplicatesResponse, CheckUserDuplicatesError, TData>({
    queryKey: queryKeyFn({
      path: '/users/check_duplicates',
      operationId: 'checkUserDuplicates',
      variables,
    }),
    queryFn: ({ signal }) => fetchCheckUserDuplicates({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type AuthorizeUserQueryParams = {
  room_id: string;
  /**
   * @default false
   */
  is_public_share?: boolean;
};

export type AuthorizeUserHeaders = {
  authorization?: string | null;
};

export type AuthorizeUserError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type AuthorizeUserVariables = {
  headers?: AuthorizeUserHeaders;
  queryParams: AuthorizeUserQueryParams;
} & NoteGoApiContext['fetcherOptions'];

/**
 * Authorizes a user to access a Liveblocks room by generating an access token.
 * Supports public share tokens (no Authorization header) as anonymous.
 *
 * IMPORTANT:
 * - Uses unified room_id (always note_id) for comment synchronization across access types
 * - Liveblocks uses the User Document ID (from Firestore), NOT the Firebase UID
 * - The JWT token must include a 'userInfo' object with id, name, email, and avatar fields
 */
export const fetchAuthorizeUser = (variables: AuthorizeUserVariables, signal?: AbortSignal) =>
  noteGoApiFetch<
    Schemas.AuthorizeUserResponse,
    AuthorizeUserError,
    undefined,
    AuthorizeUserHeaders,
    AuthorizeUserQueryParams,
    {}
  >({
    url: '/liveblocks/authorize-user',
    method: 'post',
    ...variables,
    signal,
  });

/**
 * Authorizes a user to access a Liveblocks room by generating an access token.
 * Supports public share tokens (no Authorization header) as anonymous.
 *
 * IMPORTANT:
 * - Uses unified room_id (always note_id) for comment synchronization across access types
 * - Liveblocks uses the User Document ID (from Firestore), NOT the Firebase UID
 * - The JWT token must include a 'userInfo' object with id, name, email, and avatar fields
 */
export const useAuthorizeUser = (
  options?: Omit<
    reactQuery.UseMutationOptions<Schemas.AuthorizeUserResponse, AuthorizeUserError, AuthorizeUserVariables>,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useNoteGoApiContext();
  return reactQuery.useMutation<Schemas.AuthorizeUserResponse, AuthorizeUserError, AuthorizeUserVariables>({
    mutationFn: (variables: AuthorizeUserVariables) => fetchAuthorizeUser({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ResolveUsersError = Fetcher.ErrorWrapper<undefined>;

export type ResolveUsersResponse = Schemas.ResolvedUser[];

export type ResolveUsersVariables = NoteGoApiContext['fetcherOptions'];

/**
 * Resolve user information for a list of user IDs.
 * Accepts either a raw JSON array or an object with 'userIds' (or 'user_ids') key.
 * Returns a List[ResolvedUser] in the same order, including 'anonymous'.
 *
 * IMPORTANT: The user IDs provided are User Document IDs (from Firestore), NOT Firebase UIDs.
 * This endpoint looks up users by their document IDs to return their profile information.
 */
export const fetchResolveUsers = (variables: ResolveUsersVariables, signal?: AbortSignal) =>
  noteGoApiFetch<ResolveUsersResponse, ResolveUsersError, undefined, {}, {}, {}>({
    url: '/liveblocks/resolve-users',
    method: 'post',
    ...variables,
    signal,
  });

/**
 * Resolve user information for a list of user IDs.
 * Accepts either a raw JSON array or an object with 'userIds' (or 'user_ids') key.
 * Returns a List[ResolvedUser] in the same order, including 'anonymous'.
 *
 * IMPORTANT: The user IDs provided are User Document IDs (from Firestore), NOT Firebase UIDs.
 * This endpoint looks up users by their document IDs to return their profile information.
 */
export const useResolveUsers = (
  options?: Omit<
    reactQuery.UseMutationOptions<ResolveUsersResponse, ResolveUsersError, ResolveUsersVariables>,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useNoteGoApiContext();
  return reactQuery.useMutation<ResolveUsersResponse, ResolveUsersError, ResolveUsersVariables>({
    mutationFn: (variables: ResolveUsersVariables) => fetchResolveUsers({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type HandleWebhookLiveblocksWebhookPostError = Fetcher.ErrorWrapper<undefined>;

export type HandleWebhookLiveblocksWebhookPostResponse = {
  [key: string]: string;
};

export type HandleWebhookLiveblocksWebhookPostVariables = NoteGoApiContext['fetcherOptions'];

/**
 * Handle Liveblocks webhook events. Supports both 'notification' and 'commentCreated' types.
 * 'notification' -> sends notification email via NotificationService
 * 'commentCreated' -> logs the event and returns 200
 */
export const fetchHandleWebhookLiveblocksWebhookPost = (
  variables: HandleWebhookLiveblocksWebhookPostVariables,
  signal?: AbortSignal,
) =>
  noteGoApiFetch<
    HandleWebhookLiveblocksWebhookPostResponse,
    HandleWebhookLiveblocksWebhookPostError,
    undefined,
    {},
    {},
    {}
  >({ url: '/liveblocks/webhook', method: 'post', ...variables, signal });

/**
 * Handle Liveblocks webhook events. Supports both 'notification' and 'commentCreated' types.
 * 'notification' -> sends notification email via NotificationService
 * 'commentCreated' -> logs the event and returns 200
 */
export const useHandleWebhookLiveblocksWebhookPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      HandleWebhookLiveblocksWebhookPostResponse,
      HandleWebhookLiveblocksWebhookPostError,
      HandleWebhookLiveblocksWebhookPostVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useNoteGoApiContext();
  return reactQuery.useMutation<
    HandleWebhookLiveblocksWebhookPostResponse,
    HandleWebhookLiveblocksWebhookPostError,
    HandleWebhookLiveblocksWebhookPostVariables
  >({
    mutationFn: (variables: HandleWebhookLiveblocksWebhookPostVariables) =>
      fetchHandleWebhookLiveblocksWebhookPost({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type TestWebhookLiveblocksWebhookTestPostError = Fetcher.ErrorWrapper<undefined>;

export type TestWebhookLiveblocksWebhookTestPostResponse = {
  [key: string]: any;
};

export type TestWebhookLiveblocksWebhookTestPostVariables = NoteGoApiContext['fetcherOptions'];

/**
 * Test endpoint to debug webhook issues. Logs all headers and body content.
 * Use this endpoint to test webhook delivery and identify issues.
 */
export const fetchTestWebhookLiveblocksWebhookTestPost = (
  variables: TestWebhookLiveblocksWebhookTestPostVariables,
  signal?: AbortSignal,
) =>
  noteGoApiFetch<
    TestWebhookLiveblocksWebhookTestPostResponse,
    TestWebhookLiveblocksWebhookTestPostError,
    undefined,
    {},
    {},
    {}
  >({ url: '/liveblocks/webhook-test', method: 'post', ...variables, signal });

/**
 * Test endpoint to debug webhook issues. Logs all headers and body content.
 * Use this endpoint to test webhook delivery and identify issues.
 */
export const useTestWebhookLiveblocksWebhookTestPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      TestWebhookLiveblocksWebhookTestPostResponse,
      TestWebhookLiveblocksWebhookTestPostError,
      TestWebhookLiveblocksWebhookTestPostVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useNoteGoApiContext();
  return reactQuery.useMutation<
    TestWebhookLiveblocksWebhookTestPostResponse,
    TestWebhookLiveblocksWebhookTestPostError,
    TestWebhookLiveblocksWebhookTestPostVariables
  >({
    mutationFn: (variables: TestWebhookLiveblocksWebhookTestPostVariables) =>
      fetchTestWebhookLiveblocksWebhookTestPost({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type CreateCheckoutSessionHeaders = {
  authorization: string;
};

export type CreateCheckoutSessionError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type CreateCheckoutSessionVariables = {
  body: Schemas.CheckoutSessionRequest;
  headers: CreateCheckoutSessionHeaders;
} & NoteGoApiContext['fetcherOptions'];

/**
 * Creates a Stripe checkout session for an embedded form.
 */
export const fetchCreateCheckoutSession = (variables: CreateCheckoutSessionVariables, signal?: AbortSignal) =>
  noteGoApiFetch<
    Schemas.CheckoutSessionResponse,
    CreateCheckoutSessionError,
    Schemas.CheckoutSessionRequest,
    CreateCheckoutSessionHeaders,
    {},
    {}
  >({
    url: '/subscriptions/create-checkout-session',
    method: 'post',
    ...variables,
    signal,
  });

/**
 * Creates a Stripe checkout session for an embedded form.
 */
export const useCreateCheckoutSession = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.CheckoutSessionResponse,
      CreateCheckoutSessionError,
      CreateCheckoutSessionVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useNoteGoApiContext();
  return reactQuery.useMutation<
    Schemas.CheckoutSessionResponse,
    CreateCheckoutSessionError,
    CreateCheckoutSessionVariables
  >({
    mutationFn: (variables: CreateCheckoutSessionVariables) =>
      fetchCreateCheckoutSession({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type UpdatePaymentMethodHeaders = {
  authorization: string;
};

export type UpdatePaymentMethodError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type UpdatePaymentMethodVariables = {
  body: Schemas.UpdatePaymentMethodRequest;
  headers: UpdatePaymentMethodHeaders;
} & NoteGoApiContext['fetcherOptions'];

/**
 * Creates a Stripe checkout session for an embedded form to update payment details.
 */
export const fetchUpdatePaymentMethod = (variables: UpdatePaymentMethodVariables, signal?: AbortSignal) =>
  noteGoApiFetch<
    Schemas.UpdatePaymentMethodResponse,
    UpdatePaymentMethodError,
    Schemas.UpdatePaymentMethodRequest,
    UpdatePaymentMethodHeaders,
    {},
    {}
  >({
    url: '/subscriptions/update-payment-method',
    method: 'post',
    ...variables,
    signal,
  });

/**
 * Creates a Stripe checkout session for an embedded form to update payment details.
 */
export const useUpdatePaymentMethod = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.UpdatePaymentMethodResponse,
      UpdatePaymentMethodError,
      UpdatePaymentMethodVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useNoteGoApiContext();
  return reactQuery.useMutation<
    Schemas.UpdatePaymentMethodResponse,
    UpdatePaymentMethodError,
    UpdatePaymentMethodVariables
  >({
    mutationFn: (variables: UpdatePaymentMethodVariables) =>
      fetchUpdatePaymentMethod({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type CreateSubscriptionUpdateCheckoutSessionHeaders = {
  authorization: string;
};

export type CreateSubscriptionUpdateCheckoutSessionError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type CreateSubscriptionUpdateCheckoutSessionRequestBody = {
  [key: string]: any;
};

export type CreateSubscriptionUpdateCheckoutSessionVariables = {
  body?: CreateSubscriptionUpdateCheckoutSessionRequestBody;
  headers: CreateSubscriptionUpdateCheckoutSessionHeaders;
} & NoteGoApiContext['fetcherOptions'];

/**
 * Creates a Stripe checkout session for updating a subscription payment method (setup intent).
 */
export const fetchCreateSubscriptionUpdateCheckoutSession = (
  variables: CreateSubscriptionUpdateCheckoutSessionVariables,
  signal?: AbortSignal,
) =>
  noteGoApiFetch<
    Schemas.CheckoutSessionResponse,
    CreateSubscriptionUpdateCheckoutSessionError,
    CreateSubscriptionUpdateCheckoutSessionRequestBody,
    CreateSubscriptionUpdateCheckoutSessionHeaders,
    {},
    {}
  >({
    url: '/subscriptions/create-subscription-update-checkout-session',
    method: 'post',
    ...variables,
    signal,
  });

/**
 * Creates a Stripe checkout session for updating a subscription payment method (setup intent).
 */
export const useCreateSubscriptionUpdateCheckoutSession = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.CheckoutSessionResponse,
      CreateSubscriptionUpdateCheckoutSessionError,
      CreateSubscriptionUpdateCheckoutSessionVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useNoteGoApiContext();
  return reactQuery.useMutation<
    Schemas.CheckoutSessionResponse,
    CreateSubscriptionUpdateCheckoutSessionError,
    CreateSubscriptionUpdateCheckoutSessionVariables
  >({
    mutationFn: (variables: CreateSubscriptionUpdateCheckoutSessionVariables) =>
      fetchCreateSubscriptionUpdateCheckoutSession({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type OneClickUpgradeSubscriptionHeaders = {
  authorization: string;
};

export type OneClickUpgradeSubscriptionError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type OneClickUpgradeSubscriptionRequestBody = {
  [key: string]: any;
};

export type OneClickUpgradeSubscriptionVariables = {
  body?: OneClickUpgradeSubscriptionRequestBody;
  headers: OneClickUpgradeSubscriptionHeaders;
} & NoteGoApiContext['fetcherOptions'];

/**
 * Initiates a one-click upgrade for a subscription.
 */
export const fetchOneClickUpgradeSubscription = (
  variables: OneClickUpgradeSubscriptionVariables,
  signal?: AbortSignal,
) =>
  noteGoApiFetch<
    Schemas.SubscriptionDetails,
    OneClickUpgradeSubscriptionError,
    OneClickUpgradeSubscriptionRequestBody,
    OneClickUpgradeSubscriptionHeaders,
    {},
    {}
  >({
    url: '/subscriptions/one-click-upgrade',
    method: 'post',
    ...variables,
    signal,
  });

/**
 * Initiates a one-click upgrade for a subscription.
 */
export const useOneClickUpgradeSubscription = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SubscriptionDetails,
      OneClickUpgradeSubscriptionError,
      OneClickUpgradeSubscriptionVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useNoteGoApiContext();
  return reactQuery.useMutation<
    Schemas.SubscriptionDetails,
    OneClickUpgradeSubscriptionError,
    OneClickUpgradeSubscriptionVariables
  >({
    mutationFn: (variables: OneClickUpgradeSubscriptionVariables) =>
      fetchOneClickUpgradeSubscription({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type CreatePortalSessionHeaders = {
  authorization: string;
};

export type CreatePortalSessionError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type CreatePortalSessionVariables = {
  headers: CreatePortalSessionHeaders;
} & NoteGoApiContext['fetcherOptions'];

/**
 * Creates a Stripe customer portal session.
 */
export const fetchCreatePortalSession = (variables: CreatePortalSessionVariables, signal?: AbortSignal) =>
  noteGoApiFetch<Schemas.CustomerPortal, CreatePortalSessionError, undefined, CreatePortalSessionHeaders, {}, {}>({
    url: '/subscriptions/create-portal-session',
    method: 'post',
    ...variables,
    signal,
  });

/**
 * Creates a Stripe customer portal session.
 */
export const useCreatePortalSession = (
  options?: Omit<
    reactQuery.UseMutationOptions<Schemas.CustomerPortal, CreatePortalSessionError, CreatePortalSessionVariables>,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useNoteGoApiContext();
  return reactQuery.useMutation<Schemas.CustomerPortal, CreatePortalSessionError, CreatePortalSessionVariables>({
    mutationFn: (variables: CreatePortalSessionVariables) =>
      fetchCreatePortalSession({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetSubscriptionDetailsHeaders = {
  authorization: string;
};

export type GetSubscriptionDetailsError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type GetSubscriptionDetailsVariables = {
  headers: GetSubscriptionDetailsHeaders;
} & NoteGoApiContext['fetcherOptions'];

export const fetchGetSubscriptionDetails = (variables: GetSubscriptionDetailsVariables, signal?: AbortSignal) =>
  noteGoApiFetch<
    Schemas.SubscriptionDetails,
    GetSubscriptionDetailsError,
    undefined,
    GetSubscriptionDetailsHeaders,
    {},
    {}
  >({ url: '/subscriptions/', method: 'get', ...variables, signal });

export const useGetSubscriptionDetails = <TData = Schemas.SubscriptionDetails>(
  variables: GetSubscriptionDetailsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.SubscriptionDetails, GetSubscriptionDetailsError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useNoteGoApiContext(options);
  return reactQuery.useQuery<Schemas.SubscriptionDetails, GetSubscriptionDetailsError, TData>({
    queryKey: queryKeyFn({
      path: '/subscriptions/',
      operationId: 'getSubscriptionDetails',
      variables,
    }),
    queryFn: ({ signal }) => fetchGetSubscriptionDetails({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type CancelAtPeriodEndHeaders = {
  authorization: string;
};

export type CancelAtPeriodEndError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type CancelAtPeriodEndVariables = {
  headers: CancelAtPeriodEndHeaders;
} & NoteGoApiContext['fetcherOptions'];

/**
 * Schedules a subscription cancellation at the end of the current billing period.
 * Works with or without a Subscription Schedule.
 */
export const fetchCancelAtPeriodEnd = (variables: CancelAtPeriodEndVariables, signal?: AbortSignal) =>
  noteGoApiFetch<Schemas.SubscriptionCancellation, CancelAtPeriodEndError, undefined, CancelAtPeriodEndHeaders, {}, {}>(
    {
      url: '/subscriptions/cancel-at-period-end',
      method: 'patch',
      ...variables,
      signal,
    },
  );

/**
 * Schedules a subscription cancellation at the end of the current billing period.
 * Works with or without a Subscription Schedule.
 */
export const useCancelAtPeriodEnd = (
  options?: Omit<
    reactQuery.UseMutationOptions<Schemas.SubscriptionCancellation, CancelAtPeriodEndError, CancelAtPeriodEndVariables>,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useNoteGoApiContext();
  return reactQuery.useMutation<Schemas.SubscriptionCancellation, CancelAtPeriodEndError, CancelAtPeriodEndVariables>({
    mutationFn: (variables: CancelAtPeriodEndVariables) => fetchCancelAtPeriodEnd({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type DowngradeAtPeriodEndHeaders = {
  authorization: string;
};

export type DowngradeAtPeriodEndError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type DowngradeAtPeriodEndRequestBody = {
  [key: string]: any;
};

export type DowngradeAtPeriodEndVariables = {
  body?: DowngradeAtPeriodEndRequestBody;
  headers: DowngradeAtPeriodEndHeaders;
} & NoteGoApiContext['fetcherOptions'];

export const fetchDowngradeAtPeriodEnd = (variables: DowngradeAtPeriodEndVariables, signal?: AbortSignal) =>
  noteGoApiFetch<
    Schemas.SubscriptionDowngrade,
    DowngradeAtPeriodEndError,
    DowngradeAtPeriodEndRequestBody,
    DowngradeAtPeriodEndHeaders,
    {},
    {}
  >({
    url: '/subscriptions/downgrade-at-period-end',
    method: 'post',
    ...variables,
    signal,
  });

export const useDowngradeAtPeriodEnd = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SubscriptionDowngrade,
      DowngradeAtPeriodEndError,
      DowngradeAtPeriodEndVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useNoteGoApiContext();
  return reactQuery.useMutation<
    Schemas.SubscriptionDowngrade,
    DowngradeAtPeriodEndError,
    DowngradeAtPeriodEndVariables
  >({
    mutationFn: (variables: DowngradeAtPeriodEndVariables) =>
      fetchDowngradeAtPeriodEnd({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type WebhookReceivedError = Fetcher.ErrorWrapper<undefined>;

export type WebhookReceivedVariables = NoteGoApiContext['fetcherOptions'];

/**
 * Handles Stripe webhook events.
 */
export const fetchWebhookReceived = (variables: WebhookReceivedVariables, signal?: AbortSignal) =>
  noteGoApiFetch<void, WebhookReceivedError, undefined, {}, {}, {}>({
    url: '/subscriptions/webhook',
    method: 'post',
    ...variables,
    signal,
  });

/**
 * Handles Stripe webhook events.
 */
export const useWebhookReceived = (
  options?: Omit<reactQuery.UseMutationOptions<void, WebhookReceivedError, WebhookReceivedVariables>, 'mutationFn'>,
) => {
  const { fetcherOptions } = useNoteGoApiContext();
  return reactQuery.useMutation<void, WebhookReceivedError, WebhookReceivedVariables>({
    mutationFn: (variables: WebhookReceivedVariables) => fetchWebhookReceived({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetUserStripeHeaders = {
  authorization: string;
};

export type GetUserStripeError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type GetUserStripeVariables = {
  headers: GetUserStripeHeaders;
} & NoteGoApiContext['fetcherOptions'];

export const fetchGetUserStripe = (variables: GetUserStripeVariables, signal?: AbortSignal) =>
  noteGoApiFetch<void, GetUserStripeError, undefined, GetUserStripeHeaders, {}, {}>({
    url: '/subscriptions/get-user-stripe',
    method: 'get',
    ...variables,
    signal,
  });

export const useGetUserStripe = <TData = void>(
  variables: GetUserStripeVariables,
  options?: Omit<reactQuery.UseQueryOptions<void, GetUserStripeError, TData>, 'queryKey' | 'queryFn' | 'initialData'>,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useNoteGoApiContext(options);
  return reactQuery.useQuery<void, GetUserStripeError, TData>({
    queryKey: queryKeyFn({
      path: '/subscriptions/get-user-stripe',
      operationId: 'getUserStripe',
      variables,
    }),
    queryFn: ({ signal }) => fetchGetUserStripe({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type ProcessExpiredSubscriptionsHeaders = {
  authorization: string;
};

export type ProcessExpiredSubscriptionsError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type ProcessExpiredSubscriptionsVariables = {
  headers: ProcessExpiredSubscriptionsHeaders;
} & NoteGoApiContext['fetcherOptions'];

/**
 * Manually trigger the expired subscription processing.
 * This runs the same logic as the scheduled Firebase function.
 * Requires authentication.
 */
export const fetchProcessExpiredSubscriptions = (
  variables: ProcessExpiredSubscriptionsVariables,
  signal?: AbortSignal,
) =>
  noteGoApiFetch<void, ProcessExpiredSubscriptionsError, undefined, ProcessExpiredSubscriptionsHeaders, {}, {}>({
    url: '/subscriptions/process-expired',
    method: 'post',
    ...variables,
    signal,
  });

/**
 * Manually trigger the expired subscription processing.
 * This runs the same logic as the scheduled Firebase function.
 * Requires authentication.
 */
export const useProcessExpiredSubscriptions = (
  options?: Omit<
    reactQuery.UseMutationOptions<void, ProcessExpiredSubscriptionsError, ProcessExpiredSubscriptionsVariables>,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useNoteGoApiContext();
  return reactQuery.useMutation<void, ProcessExpiredSubscriptionsError, ProcessExpiredSubscriptionsVariables>({
    mutationFn: (variables: ProcessExpiredSubscriptionsVariables) =>
      fetchProcessExpiredSubscriptions({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type SendNotificationError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type SendNotificationVariables = {
  body: Schemas.NotificationRequest;
} & NoteGoApiContext['fetcherOptions'];

/**
 * Lookup the target user by ID and enqueue an email with the given message.
 */
export const fetchSendNotification = (variables: SendNotificationVariables, signal?: AbortSignal) =>
  noteGoApiFetch<undefined, SendNotificationError, Schemas.NotificationRequest, {}, {}, {}>({
    url: '/notifications/send',
    method: 'post',
    ...variables,
    signal,
  });

/**
 * Lookup the target user by ID and enqueue an email with the given message.
 */
export const useSendNotification = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, SendNotificationError, SendNotificationVariables>,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useNoteGoApiContext();
  return reactQuery.useMutation<undefined, SendNotificationError, SendNotificationVariables>({
    mutationFn: (variables: SendNotificationVariables) => fetchSendNotification({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ExtensionAuthPageAuthExtensionGetQueryParams = {
  /**
   * State parameter for CSRF protection
   */
  state: string;
  /**
   * Environment identifier
   *
   * @default notegostaging
   */
  env?: string;
  /**
   * Redirect URL after auth
   *
   * @default
   */
  redirect?: string;
  /**
   * Source identifier
   *
   * @default extension
   */
  source?: string;
};

export type ExtensionAuthPageAuthExtensionGetError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type ExtensionAuthPageAuthExtensionGetVariables = {
  queryParams: ExtensionAuthPageAuthExtensionGetQueryParams;
} & NoteGoApiContext['fetcherOptions'];

/**
 * Authentication page specifically for Chrome extension.
 * This page loads your web app with special extension authentication handling.
 */
export const fetchExtensionAuthPageAuthExtensionGet = (
  variables: ExtensionAuthPageAuthExtensionGetVariables,
  signal?: AbortSignal,
) =>
  noteGoApiFetch<
    undefined,
    ExtensionAuthPageAuthExtensionGetError,
    undefined,
    {},
    ExtensionAuthPageAuthExtensionGetQueryParams,
    {}
  >({ url: '/auth/extension', method: 'get', ...variables, signal });

/**
 * Authentication page specifically for Chrome extension.
 * This page loads your web app with special extension authentication handling.
 */
export const useExtensionAuthPageAuthExtensionGet = <TData = undefined>(
  variables: ExtensionAuthPageAuthExtensionGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, ExtensionAuthPageAuthExtensionGetError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useNoteGoApiContext(options);
  return reactQuery.useQuery<undefined, ExtensionAuthPageAuthExtensionGetError, TData>({
    queryKey: queryKeyFn({
      path: '/auth/extension',
      operationId: 'extensionAuthPageAuthExtensionGet',
      variables,
    }),
    queryFn: ({ signal }) => fetchExtensionAuthPageAuthExtensionGet({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type ExtensionAuthCallbackAuthExtensionCallbackPostQueryParams = {
  state: string;
  token: string;
  redirect_url?: string;
};

export type ExtensionAuthCallbackAuthExtensionCallbackPostError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type ExtensionAuthCallbackAuthExtensionCallbackPostVariables = {
  queryParams: ExtensionAuthCallbackAuthExtensionCallbackPostQueryParams;
} & NoteGoApiContext['fetcherOptions'];

/**
 * Callback endpoint for extension authentication.
 * This would be called if we needed server-side token validation.
 */
export const fetchExtensionAuthCallbackAuthExtensionCallbackPost = (
  variables: ExtensionAuthCallbackAuthExtensionCallbackPostVariables,
  signal?: AbortSignal,
) =>
  noteGoApiFetch<
    void,
    ExtensionAuthCallbackAuthExtensionCallbackPostError,
    undefined,
    {},
    ExtensionAuthCallbackAuthExtensionCallbackPostQueryParams,
    {}
  >({ url: '/auth/extension/callback', method: 'post', ...variables, signal });

/**
 * Callback endpoint for extension authentication.
 * This would be called if we needed server-side token validation.
 */
export const useExtensionAuthCallbackAuthExtensionCallbackPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      void,
      ExtensionAuthCallbackAuthExtensionCallbackPostError,
      ExtensionAuthCallbackAuthExtensionCallbackPostVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useNoteGoApiContext();
  return reactQuery.useMutation<
    void,
    ExtensionAuthCallbackAuthExtensionCallbackPostError,
    ExtensionAuthCallbackAuthExtensionCallbackPostVariables
  >({
    mutationFn: (variables: ExtensionAuthCallbackAuthExtensionCallbackPostVariables) =>
      fetchExtensionAuthCallbackAuthExtensionCallbackPost({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ExchangeTokenForCustomTokenApiAuthExchangeTokenPostHeaders = {
  authorization?: string | null;
};

export type ExchangeTokenForCustomTokenApiAuthExchangeTokenPostError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type ExchangeTokenForCustomTokenApiAuthExchangeTokenPostResponse = {
  [key: string]: any;
};

export type ExchangeTokenForCustomTokenApiAuthExchangeTokenPostVariables = {
  headers?: ExchangeTokenForCustomTokenApiAuthExchangeTokenPostHeaders;
} & NoteGoApiContext['fetcherOptions'];

/**
 * Exchange a valid Firebase ID token for a custom token.
 *
 * This enables SSO between the Chrome extension and web app:
 * - Extension authenticates user and gets Firebase ID token
 * - Extension sends token to web app via postMessage
 * - Web app calls this endpoint to get a custom token
 * - Web app uses custom token to sign in with Firebase Auth
 *
 * This is secure because:
 * - The incoming token is verified against Firebase
 * - Custom tokens are short-lived (1 hour by default)
 * - The custom token is tied to the same user ID
 *
 * Returns:
 *     Dict containing the custom token for Firebase signInWithCustomToken
 */
export const fetchExchangeTokenForCustomTokenApiAuthExchangeTokenPost = (
  variables: ExchangeTokenForCustomTokenApiAuthExchangeTokenPostVariables,
  signal?: AbortSignal,
) =>
  noteGoApiFetch<
    ExchangeTokenForCustomTokenApiAuthExchangeTokenPostResponse,
    ExchangeTokenForCustomTokenApiAuthExchangeTokenPostError,
    undefined,
    ExchangeTokenForCustomTokenApiAuthExchangeTokenPostHeaders,
    {},
    {}
  >({ url: '/api/auth/exchange-token', method: 'post', ...variables, signal });

/**
 * Exchange a valid Firebase ID token for a custom token.
 *
 * This enables SSO between the Chrome extension and web app:
 * - Extension authenticates user and gets Firebase ID token
 * - Extension sends token to web app via postMessage
 * - Web app calls this endpoint to get a custom token
 * - Web app uses custom token to sign in with Firebase Auth
 *
 * This is secure because:
 * - The incoming token is verified against Firebase
 * - Custom tokens are short-lived (1 hour by default)
 * - The custom token is tied to the same user ID
 *
 * Returns:
 *     Dict containing the custom token for Firebase signInWithCustomToken
 */
export const useExchangeTokenForCustomTokenApiAuthExchangeTokenPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      ExchangeTokenForCustomTokenApiAuthExchangeTokenPostResponse,
      ExchangeTokenForCustomTokenApiAuthExchangeTokenPostError,
      ExchangeTokenForCustomTokenApiAuthExchangeTokenPostVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useNoteGoApiContext();
  return reactQuery.useMutation<
    ExchangeTokenForCustomTokenApiAuthExchangeTokenPostResponse,
    ExchangeTokenForCustomTokenApiAuthExchangeTokenPostError,
    ExchangeTokenForCustomTokenApiAuthExchangeTokenPostVariables
  >({
    mutationFn: (variables: ExchangeTokenForCustomTokenApiAuthExchangeTokenPostVariables) =>
      fetchExchangeTokenForCustomTokenApiAuthExchangeTokenPost({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type GetExtensionStatusApiExtensionStatusGetHeaders = {
  authorization?: string | null;
};

export type GetExtensionStatusApiExtensionStatusGetError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type GetExtensionStatusApiExtensionStatusGetResponse = {
  [key: string]: any;
};

export type GetExtensionStatusApiExtensionStatusGetVariables = {
  headers?: GetExtensionStatusApiExtensionStatusGetHeaders;
} & NoteGoApiContext['fetcherOptions'];

/**
 * Get the current authentication and plan status for the Chrome extension.
 *
 * This endpoint can be called with or without authentication:
 * - Without auth: Returns unauthenticated status
 * - With auth: Returns user info and plan details
 *
 * Returns:
 *     Dict containing authentication status, user info (if authenticated),
 *     and plan details (if authenticated)
 */
export const fetchGetExtensionStatusApiExtensionStatusGet = (
  variables: GetExtensionStatusApiExtensionStatusGetVariables,
  signal?: AbortSignal,
) =>
  noteGoApiFetch<
    GetExtensionStatusApiExtensionStatusGetResponse,
    GetExtensionStatusApiExtensionStatusGetError,
    undefined,
    GetExtensionStatusApiExtensionStatusGetHeaders,
    {},
    {}
  >({ url: '/api/extension/status', method: 'get', ...variables, signal });

/**
 * Get the current authentication and plan status for the Chrome extension.
 *
 * This endpoint can be called with or without authentication:
 * - Without auth: Returns unauthenticated status
 * - With auth: Returns user info and plan details
 *
 * Returns:
 *     Dict containing authentication status, user info (if authenticated),
 *     and plan details (if authenticated)
 */
export const useGetExtensionStatusApiExtensionStatusGet = <TData = GetExtensionStatusApiExtensionStatusGetResponse>(
  variables: GetExtensionStatusApiExtensionStatusGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetExtensionStatusApiExtensionStatusGetResponse,
      GetExtensionStatusApiExtensionStatusGetError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useNoteGoApiContext(options);
  return reactQuery.useQuery<
    GetExtensionStatusApiExtensionStatusGetResponse,
    GetExtensionStatusApiExtensionStatusGetError,
    TData
  >({
    queryKey: queryKeyFn({
      path: '/api/extension/status',
      operationId: 'getExtensionStatusApiExtensionStatusGet',
      variables,
    }),
    queryFn: ({ signal }) => fetchGetExtensionStatusApiExtensionStatusGet({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type CreateSupportTicketSupportTicketPostError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type CreateSupportTicketSupportTicketPostVariables = {
  body?: Schemas.SupportTicketRequest;
} & NoteGoApiContext['fetcherOptions'];

/**
 * Create a support ticket from extension diagnostic data.
 * No authentication required as per requirements.
 */
export const fetchCreateSupportTicketSupportTicketPost = (
  variables: CreateSupportTicketSupportTicketPostVariables,
  signal?: AbortSignal,
) =>
  noteGoApiFetch<
    Schemas.SupportTicketResponse,
    CreateSupportTicketSupportTicketPostError,
    Schemas.SupportTicketRequest,
    {},
    {},
    {}
  >({ url: '/support/ticket', method: 'post', ...variables, signal });

/**
 * Create a support ticket from extension diagnostic data.
 * No authentication required as per requirements.
 */
export const useCreateSupportTicketSupportTicketPost = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SupportTicketResponse,
      CreateSupportTicketSupportTicketPostError,
      CreateSupportTicketSupportTicketPostVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useNoteGoApiContext();
  return reactQuery.useMutation<
    Schemas.SupportTicketResponse,
    CreateSupportTicketSupportTicketPostError,
    CreateSupportTicketSupportTicketPostVariables
  >({
    mutationFn: (variables: CreateSupportTicketSupportTicketPostVariables) =>
      fetchCreateSupportTicketSupportTicketPost({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type GetUserTagsHeaders = {
  authorization: string;
};

export type GetUserTagsError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type GetUserTagsVariables = {
  headers: GetUserTagsHeaders;
} & NoteGoApiContext['fetcherOptions'];

export const fetchGetUserTags = (variables: GetUserTagsVariables, signal?: AbortSignal) =>
  noteGoApiFetch<Schemas.TagListResponse, GetUserTagsError, undefined, GetUserTagsHeaders, {}, {}>({
    url: '/tags/user-tags',
    method: 'get',
    ...variables,
    signal,
  });

export const useGetUserTags = <TData = Schemas.TagListResponse>(
  variables: GetUserTagsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.TagListResponse, GetUserTagsError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useNoteGoApiContext(options);
  return reactQuery.useQuery<Schemas.TagListResponse, GetUserTagsError, TData>({
    queryKey: queryKeyFn({
      path: '/tags/user-tags',
      operationId: 'getUserTags',
      variables,
    }),
    queryFn: ({ signal }) => fetchGetUserTags({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type GetUserTagsDirectHeaders = {
  authorization: string;
};

export type GetUserTagsDirectError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type GetUserTagsDirectResponse = string[];

export type GetUserTagsDirectVariables = {
  headers: GetUserTagsDirectHeaders;
} & NoteGoApiContext['fetcherOptions'];

/**
 * Get tags directly from the user document.
 * Returns a simple list of tag strings.
 */
export const fetchGetUserTagsDirect = (variables: GetUserTagsDirectVariables, signal?: AbortSignal) =>
  noteGoApiFetch<GetUserTagsDirectResponse, GetUserTagsDirectError, undefined, GetUserTagsDirectHeaders, {}, {}>({
    url: '/tags/user-tags-direct',
    method: 'get',
    ...variables,
    signal,
  });

/**
 * Get tags directly from the user document.
 * Returns a simple list of tag strings.
 */
export const useGetUserTagsDirect = <TData = GetUserTagsDirectResponse>(
  variables: GetUserTagsDirectVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<GetUserTagsDirectResponse, GetUserTagsDirectError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useNoteGoApiContext(options);
  return reactQuery.useQuery<GetUserTagsDirectResponse, GetUserTagsDirectError, TData>({
    queryKey: queryKeyFn({
      path: '/tags/user-tags-direct',
      operationId: 'getUserTagsDirect',
      variables,
    }),
    queryFn: ({ signal }) => fetchGetUserTagsDirect({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type MergeTagsHeaders = {
  authorization: string;
};

export type MergeTagsError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type MergeTagsVariables = {
  body: Schemas.TagMergeRequest;
  headers: MergeTagsHeaders;
} & NoteGoApiContext['fetcherOptions'];

export const fetchMergeTags = (variables: MergeTagsVariables, signal?: AbortSignal) =>
  noteGoApiFetch<Schemas.TagMergeResponse, MergeTagsError, Schemas.TagMergeRequest, MergeTagsHeaders, {}, {}>({
    url: '/tags/merge',
    method: 'post',
    ...variables,
    signal,
  });

export const useMergeTags = (
  options?: Omit<
    reactQuery.UseMutationOptions<Schemas.TagMergeResponse, MergeTagsError, MergeTagsVariables>,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useNoteGoApiContext();
  return reactQuery.useMutation<Schemas.TagMergeResponse, MergeTagsError, MergeTagsVariables>({
    mutationFn: (variables: MergeTagsVariables) => fetchMergeTags({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetSecondBrainChatsHeaders = {
  authorization: string;
};

export type GetSecondBrainChatsError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type GetSecondBrainChatsResponse = Schemas.SecondBrainChatResponse[];

export type GetSecondBrainChatsVariables = {
  headers: GetSecondBrainChatsHeaders;
} & NoteGoApiContext['fetcherOptions'];

/**
 * Get user's Second Brain chat history
 *
 * Returns a list of all chats for the authenticated user, ordered by creation date (newest first).
 */
export const fetchGetSecondBrainChats = (variables: GetSecondBrainChatsVariables, signal?: AbortSignal) =>
  noteGoApiFetch<GetSecondBrainChatsResponse, GetSecondBrainChatsError, undefined, GetSecondBrainChatsHeaders, {}, {}>({
    url: '/second-brain/chats',
    method: 'get',
    ...variables,
    signal,
  });

/**
 * Get user's Second Brain chat history
 *
 * Returns a list of all chats for the authenticated user, ordered by creation date (newest first).
 */
export const useGetSecondBrainChats = <TData = GetSecondBrainChatsResponse>(
  variables: GetSecondBrainChatsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<GetSecondBrainChatsResponse, GetSecondBrainChatsError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useNoteGoApiContext(options);
  return reactQuery.useQuery<GetSecondBrainChatsResponse, GetSecondBrainChatsError, TData>({
    queryKey: queryKeyFn({
      path: '/second-brain/chats',
      operationId: 'getSecondBrainChats',
      variables,
    }),
    queryFn: ({ signal }) => fetchGetSecondBrainChats({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type CreateSecondBrainChatHeaders = {
  authorization: string;
};

export type CreateSecondBrainChatError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type CreateSecondBrainChatVariables = {
  body: Schemas.SecondBrainChatRequest;
  headers: CreateSecondBrainChatHeaders;
} & NoteGoApiContext['fetcherOptions'];

/**
 * Create a new Second Brain chat with streaming response
 *
 * Accepts a question and context notes, streams the Gemini AI response back to the client,
 * and saves the complete chat to Firestore.
 *
 * The response is streamed using Server-Sent Events (SSE) format.
 */
export const fetchCreateSecondBrainChat = (variables: CreateSecondBrainChatVariables, signal?: AbortSignal) =>
  noteGoApiFetch<
    void,
    CreateSecondBrainChatError,
    Schemas.SecondBrainChatRequest,
    CreateSecondBrainChatHeaders,
    {},
    {}
  >({ url: '/second-brain/chats', method: 'post', ...variables, signal });

/**
 * Create a new Second Brain chat with streaming response
 *
 * Accepts a question and context notes, streams the Gemini AI response back to the client,
 * and saves the complete chat to Firestore.
 *
 * The response is streamed using Server-Sent Events (SSE) format.
 */
export const useCreateSecondBrainChat = (
  options?: Omit<
    reactQuery.UseMutationOptions<void, CreateSecondBrainChatError, CreateSecondBrainChatVariables>,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useNoteGoApiContext();
  return reactQuery.useMutation<void, CreateSecondBrainChatError, CreateSecondBrainChatVariables>({
    mutationFn: (variables: CreateSecondBrainChatVariables) =>
      fetchCreateSecondBrainChat({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetSecondBrainChatPathParams = {
  chatId: string;
};

export type GetSecondBrainChatHeaders = {
  authorization: string;
};

export type GetSecondBrainChatError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type GetSecondBrainChatVariables = {
  headers: GetSecondBrainChatHeaders;
  pathParams: GetSecondBrainChatPathParams;
} & NoteGoApiContext['fetcherOptions'];

/**
 * Get a specific Second Brain chat by ID
 *
 * Returns the complete chat including all messages and context notes.
 * Only the chat owner can access their chats.
 */
export const fetchGetSecondBrainChat = (variables: GetSecondBrainChatVariables, signal?: AbortSignal) =>
  noteGoApiFetch<
    Schemas.SecondBrainChatResponse,
    GetSecondBrainChatError,
    undefined,
    GetSecondBrainChatHeaders,
    {},
    GetSecondBrainChatPathParams
  >({
    url: '/second-brain/chats/{chatId}',
    method: 'get',
    ...variables,
    signal,
  });

/**
 * Get a specific Second Brain chat by ID
 *
 * Returns the complete chat including all messages and context notes.
 * Only the chat owner can access their chats.
 */
export const useGetSecondBrainChat = <TData = Schemas.SecondBrainChatResponse>(
  variables: GetSecondBrainChatVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.SecondBrainChatResponse, GetSecondBrainChatError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useNoteGoApiContext(options);
  return reactQuery.useQuery<Schemas.SecondBrainChatResponse, GetSecondBrainChatError, TData>({
    queryKey: queryKeyFn({
      path: '/second-brain/chats/{chatId}',
      operationId: 'getSecondBrainChat',
      variables,
    }),
    queryFn: ({ signal }) => fetchGetSecondBrainChat({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type DeleteSecondBrainChatPathParams = {
  chatId: string;
};

export type DeleteSecondBrainChatHeaders = {
  authorization: string;
};

export type DeleteSecondBrainChatError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type DeleteSecondBrainChatVariables = {
  headers: DeleteSecondBrainChatHeaders;
  pathParams: DeleteSecondBrainChatPathParams;
} & NoteGoApiContext['fetcherOptions'];

/**
 * Delete a Second Brain chat
 *
 * Permanently deletes the specified chat. Only the chat owner can delete their chats.
 */
export const fetchDeleteSecondBrainChat = (variables: DeleteSecondBrainChatVariables, signal?: AbortSignal) =>
  noteGoApiFetch<
    undefined,
    DeleteSecondBrainChatError,
    undefined,
    DeleteSecondBrainChatHeaders,
    {},
    DeleteSecondBrainChatPathParams
  >({
    url: '/second-brain/chats/{chatId}',
    method: 'delete',
    ...variables,
    signal,
  });

/**
 * Delete a Second Brain chat
 *
 * Permanently deletes the specified chat. Only the chat owner can delete their chats.
 */
export const useDeleteSecondBrainChat = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, DeleteSecondBrainChatError, DeleteSecondBrainChatVariables>,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useNoteGoApiContext();
  return reactQuery.useMutation<undefined, DeleteSecondBrainChatError, DeleteSecondBrainChatVariables>({
    mutationFn: (variables: DeleteSecondBrainChatVariables) =>
      fetchDeleteSecondBrainChat({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type CreateOrganizationHeaders = {
  authorization: string;
};

export type CreateOrganizationError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type CreateOrganizationVariables = {
  body: Schemas.OrganizationCreate;
  headers: CreateOrganizationHeaders;
} & NoteGoApiContext['fetcherOptions'];

/**
 * Create a new organization
 */
export const fetchCreateOrganization = (variables: CreateOrganizationVariables, signal?: AbortSignal) =>
  noteGoApiFetch<
    Schemas.OrganizationOut,
    CreateOrganizationError,
    Schemas.OrganizationCreate,
    CreateOrganizationHeaders,
    {},
    {}
  >({ url: '/organizations/', method: 'post', ...variables, signal });

/**
 * Create a new organization
 */
export const useCreateOrganization = (
  options?: Omit<
    reactQuery.UseMutationOptions<Schemas.OrganizationOut, CreateOrganizationError, CreateOrganizationVariables>,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useNoteGoApiContext();
  return reactQuery.useMutation<Schemas.OrganizationOut, CreateOrganizationError, CreateOrganizationVariables>({
    mutationFn: (variables: CreateOrganizationVariables) =>
      fetchCreateOrganization({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetOrganizationsHeaders = {
  authorization: string;
};

export type GetOrganizationsError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type GetOrganizationsVariables = {
  headers: GetOrganizationsHeaders;
} & NoteGoApiContext['fetcherOptions'];

/**
 * Get all organizations where user is a member
 */
export const fetchGetOrganizations = (variables: GetOrganizationsVariables, signal?: AbortSignal) =>
  noteGoApiFetch<Schemas.OrganizationListResponse, GetOrganizationsError, undefined, GetOrganizationsHeaders, {}, {}>({
    url: '/organizations/',
    method: 'get',
    ...variables,
    signal,
  });

/**
 * Get all organizations where user is a member
 */
export const useGetOrganizations = <TData = Schemas.OrganizationListResponse>(
  variables: GetOrganizationsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.OrganizationListResponse, GetOrganizationsError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useNoteGoApiContext(options);
  return reactQuery.useQuery<Schemas.OrganizationListResponse, GetOrganizationsError, TData>({
    queryKey: queryKeyFn({
      path: '/organizations/',
      operationId: 'getOrganizations',
      variables,
    }),
    queryFn: ({ signal }) => fetchGetOrganizations({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type GetOrganizationPathParams = {
  organizationId: string;
};

export type GetOrganizationHeaders = {
  authorization: string;
};

export type GetOrganizationError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type GetOrganizationVariables = {
  headers: GetOrganizationHeaders;
  pathParams: GetOrganizationPathParams;
} & NoteGoApiContext['fetcherOptions'];

/**
 * Get an organization by ID
 */
export const fetchGetOrganization = (variables: GetOrganizationVariables, signal?: AbortSignal) =>
  noteGoApiFetch<
    Schemas.OrganizationOut,
    GetOrganizationError,
    undefined,
    GetOrganizationHeaders,
    {},
    GetOrganizationPathParams
  >({
    url: '/organizations/{organizationId}',
    method: 'get',
    ...variables,
    signal,
  });

/**
 * Get an organization by ID
 */
export const useGetOrganization = <TData = Schemas.OrganizationOut>(
  variables: GetOrganizationVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.OrganizationOut, GetOrganizationError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useNoteGoApiContext(options);
  return reactQuery.useQuery<Schemas.OrganizationOut, GetOrganizationError, TData>({
    queryKey: queryKeyFn({
      path: '/organizations/{organizationId}',
      operationId: 'getOrganization',
      variables,
    }),
    queryFn: ({ signal }) => fetchGetOrganization({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type UpdateOrganizationPathParams = {
  organizationId: string;
};

export type UpdateOrganizationHeaders = {
  authorization: string;
};

export type UpdateOrganizationError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type UpdateOrganizationVariables = {
  body?: Schemas.OrganizationUpdate;
  headers: UpdateOrganizationHeaders;
  pathParams: UpdateOrganizationPathParams;
} & NoteGoApiContext['fetcherOptions'];

/**
 * Update an organization (owner only)
 */
export const fetchUpdateOrganization = (variables: UpdateOrganizationVariables, signal?: AbortSignal) =>
  noteGoApiFetch<
    Schemas.OrganizationOut,
    UpdateOrganizationError,
    Schemas.OrganizationUpdate,
    UpdateOrganizationHeaders,
    {},
    UpdateOrganizationPathParams
  >({
    url: '/organizations/{organizationId}',
    method: 'put',
    ...variables,
    signal,
  });

/**
 * Update an organization (owner only)
 */
export const useUpdateOrganization = (
  options?: Omit<
    reactQuery.UseMutationOptions<Schemas.OrganizationOut, UpdateOrganizationError, UpdateOrganizationVariables>,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useNoteGoApiContext();
  return reactQuery.useMutation<Schemas.OrganizationOut, UpdateOrganizationError, UpdateOrganizationVariables>({
    mutationFn: (variables: UpdateOrganizationVariables) =>
      fetchUpdateOrganization({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type DeleteOrganizationPathParams = {
  organizationId: string;
};

export type DeleteOrganizationHeaders = {
  authorization: string;
};

export type DeleteOrganizationError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type DeleteOrganizationVariables = {
  headers: DeleteOrganizationHeaders;
  pathParams: DeleteOrganizationPathParams;
} & NoteGoApiContext['fetcherOptions'];

/**
 * Delete an organization (owner only)
 */
export const fetchDeleteOrganization = (variables: DeleteOrganizationVariables, signal?: AbortSignal) =>
  noteGoApiFetch<
    undefined,
    DeleteOrganizationError,
    undefined,
    DeleteOrganizationHeaders,
    {},
    DeleteOrganizationPathParams
  >({
    url: '/organizations/{organizationId}',
    method: 'delete',
    ...variables,
    signal,
  });

/**
 * Delete an organization (owner only)
 */
export const useDeleteOrganization = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, DeleteOrganizationError, DeleteOrganizationVariables>,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useNoteGoApiContext();
  return reactQuery.useMutation<undefined, DeleteOrganizationError, DeleteOrganizationVariables>({
    mutationFn: (variables: DeleteOrganizationVariables) =>
      fetchDeleteOrganization({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type AddOrganizationMemberPathParams = {
  organizationId: string;
};

export type AddOrganizationMemberHeaders = {
  authorization: string;
};

export type AddOrganizationMemberError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type AddOrganizationMemberVariables = {
  body: Schemas.OrganizationMemberAdd;
  headers: AddOrganizationMemberHeaders;
  pathParams: AddOrganizationMemberPathParams;
} & NoteGoApiContext['fetcherOptions'];

/**
 * Add a member to an organization (owner only)
 */
export const fetchAddOrganizationMember = (variables: AddOrganizationMemberVariables, signal?: AbortSignal) =>
  noteGoApiFetch<
    Schemas.OrganizationOut,
    AddOrganizationMemberError,
    Schemas.OrganizationMemberAdd,
    AddOrganizationMemberHeaders,
    {},
    AddOrganizationMemberPathParams
  >({
    url: '/organizations/{organizationId}/members',
    method: 'post',
    ...variables,
    signal,
  });

/**
 * Add a member to an organization (owner only)
 */
export const useAddOrganizationMember = (
  options?: Omit<
    reactQuery.UseMutationOptions<Schemas.OrganizationOut, AddOrganizationMemberError, AddOrganizationMemberVariables>,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useNoteGoApiContext();
  return reactQuery.useMutation<Schemas.OrganizationOut, AddOrganizationMemberError, AddOrganizationMemberVariables>({
    mutationFn: (variables: AddOrganizationMemberVariables) =>
      fetchAddOrganizationMember({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type RemoveOrganizationMemberPathParams = {
  organizationId: string;
  memberEmail: string;
};

export type RemoveOrganizationMemberHeaders = {
  authorization: string;
};

export type RemoveOrganizationMemberError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type RemoveOrganizationMemberVariables = {
  headers: RemoveOrganizationMemberHeaders;
  pathParams: RemoveOrganizationMemberPathParams;
} & NoteGoApiContext['fetcherOptions'];

/**
 * Remove a member from an organization (owner only)
 */
export const fetchRemoveOrganizationMember = (variables: RemoveOrganizationMemberVariables, signal?: AbortSignal) =>
  noteGoApiFetch<
    Schemas.OrganizationOut,
    RemoveOrganizationMemberError,
    undefined,
    RemoveOrganizationMemberHeaders,
    {},
    RemoveOrganizationMemberPathParams
  >({
    url: '/organizations/{organizationId}/members/{memberEmail}',
    method: 'delete',
    ...variables,
    signal,
  });

/**
 * Remove a member from an organization (owner only)
 */
export const useRemoveOrganizationMember = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.OrganizationOut,
      RemoveOrganizationMemberError,
      RemoveOrganizationMemberVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useNoteGoApiContext();
  return reactQuery.useMutation<
    Schemas.OrganizationOut,
    RemoveOrganizationMemberError,
    RemoveOrganizationMemberVariables
  >({
    mutationFn: (variables: RemoveOrganizationMemberVariables) =>
      fetchRemoveOrganizationMember({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type AddOrganizationNotePathParams = {
  organizationId: string;
};

export type AddOrganizationNoteHeaders = {
  authorization: string;
};

export type AddOrganizationNoteError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type AddOrganizationNoteVariables = {
  body: Schemas.OrganizationNoteAdd;
  headers: AddOrganizationNoteHeaders;
  pathParams: AddOrganizationNotePathParams;
} & NoteGoApiContext['fetcherOptions'];

/**
 * Add a note to an organization (owner only)
 */
export const fetchAddOrganizationNote = (variables: AddOrganizationNoteVariables, signal?: AbortSignal) =>
  noteGoApiFetch<
    Schemas.OrganizationOut,
    AddOrganizationNoteError,
    Schemas.OrganizationNoteAdd,
    AddOrganizationNoteHeaders,
    {},
    AddOrganizationNotePathParams
  >({
    url: '/organizations/{organizationId}/notes',
    method: 'post',
    ...variables,
    signal,
  });

/**
 * Add a note to an organization (owner only)
 */
export const useAddOrganizationNote = (
  options?: Omit<
    reactQuery.UseMutationOptions<Schemas.OrganizationOut, AddOrganizationNoteError, AddOrganizationNoteVariables>,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useNoteGoApiContext();
  return reactQuery.useMutation<Schemas.OrganizationOut, AddOrganizationNoteError, AddOrganizationNoteVariables>({
    mutationFn: (variables: AddOrganizationNoteVariables) =>
      fetchAddOrganizationNote({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type RemoveOrganizationNotePathParams = {
  organizationId: string;
  noteId: string;
};

export type RemoveOrganizationNoteHeaders = {
  authorization: string;
};

export type RemoveOrganizationNoteError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type RemoveOrganizationNoteVariables = {
  headers: RemoveOrganizationNoteHeaders;
  pathParams: RemoveOrganizationNotePathParams;
} & NoteGoApiContext['fetcherOptions'];

/**
 * Remove a note from an organization (owner only)
 */
export const fetchRemoveOrganizationNote = (variables: RemoveOrganizationNoteVariables, signal?: AbortSignal) =>
  noteGoApiFetch<
    Schemas.OrganizationOut,
    RemoveOrganizationNoteError,
    undefined,
    RemoveOrganizationNoteHeaders,
    {},
    RemoveOrganizationNotePathParams
  >({
    url: '/organizations/{organizationId}/notes/{noteId}',
    method: 'delete',
    ...variables,
    signal,
  });

/**
 * Remove a note from an organization (owner only)
 */
export const useRemoveOrganizationNote = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.OrganizationOut,
      RemoveOrganizationNoteError,
      RemoveOrganizationNoteVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useNoteGoApiContext();
  return reactQuery.useMutation<Schemas.OrganizationOut, RemoveOrganizationNoteError, RemoveOrganizationNoteVariables>({
    mutationFn: (variables: RemoveOrganizationNoteVariables) =>
      fetchRemoveOrganizationNote({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetOrganizationNotePathParams = {
  organizationId: string;
  noteId: string;
};

export type GetOrganizationNoteHeaders = {
  authorization: string;
};

export type GetOrganizationNoteError = Fetcher.ErrorWrapper<{
  status: 422;
  payload: Schemas.HTTPValidationError;
}>;

export type GetOrganizationNoteVariables = {
  headers: GetOrganizationNoteHeaders;
  pathParams: GetOrganizationNotePathParams;
} & NoteGoApiContext['fetcherOptions'];

/**
 * Get a note via organization membership (bypasses normal note access checks)
 */
export const fetchGetOrganizationNote = (variables: GetOrganizationNoteVariables, signal?: AbortSignal) =>
  noteGoApiFetch<
    Schemas.NoteOut,
    GetOrganizationNoteError,
    undefined,
    GetOrganizationNoteHeaders,
    {},
    GetOrganizationNotePathParams
  >({
    url: '/organizations/{organizationId}/notes/{noteId}',
    method: 'get',
    ...variables,
    signal,
  });

/**
 * Get a note via organization membership (bypasses normal note access checks)
 */
export const useGetOrganizationNote = <TData = Schemas.NoteOut>(
  variables: GetOrganizationNoteVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.NoteOut, GetOrganizationNoteError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useNoteGoApiContext(options);
  return reactQuery.useQuery<Schemas.NoteOut, GetOrganizationNoteError, TData>({
    queryKey: queryKeyFn({
      path: '/organizations/{organizationId}/notes/{noteId}',
      operationId: 'getOrganizationNote',
      variables,
    }),
    queryFn: ({ signal }) => fetchGetOrganizationNote({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type QueryOperation =
  | {
      path: '/';
      operationId: 'rootGet';
      variables: RootGetVariables;
    }
  | {
      path: '/test';
      operationId: 'testTestGet';
      variables: TestTestGetVariables;
    }
  | {
      path: '/healthz';
      operationId: 'healthcheckHealthzGet';
      variables: HealthcheckHealthzGetVariables;
    }
  | {
      path: '/shared/{token}';
      operationId: 'getSharedNote';
      variables: GetSharedNoteVariables;
    }
  | {
      path: '/notes/{noteId}';
      operationId: 'getNote';
      variables: GetNoteVariables;
    }
  | {
      path: '/notes/';
      operationId: 'getAllNotes';
      variables: GetAllNotesVariables;
    }
  | {
      path: '/notes/search/';
      operationId: 'searchNotes';
      variables: SearchNotesVariables;
    }
  | {
      path: '/notes/my-notes/';
      operationId: 'getMyNotesDirect';
      variables: GetMyNotesDirectVariables;
    }
  | {
      path: '/users/me';
      operationId: 'getUser';
      variables: GetUserVariables;
    }
  | {
      path: '/users/';
      operationId: 'getUsersByIds';
      variables: GetUsersByIdsVariables;
    }
  | {
      path: '/users/check_duplicates';
      operationId: 'checkUserDuplicates';
      variables: CheckUserDuplicatesVariables;
    }
  | {
      path: '/subscriptions/';
      operationId: 'getSubscriptionDetails';
      variables: GetSubscriptionDetailsVariables;
    }
  | {
      path: '/subscriptions/get-user-stripe';
      operationId: 'getUserStripe';
      variables: GetUserStripeVariables;
    }
  | {
      path: '/auth/extension';
      operationId: 'extensionAuthPageAuthExtensionGet';
      variables: ExtensionAuthPageAuthExtensionGetVariables;
    }
  | {
      path: '/api/extension/status';
      operationId: 'getExtensionStatusApiExtensionStatusGet';
      variables: GetExtensionStatusApiExtensionStatusGetVariables;
    }
  | {
      path: '/tags/user-tags';
      operationId: 'getUserTags';
      variables: GetUserTagsVariables;
    }
  | {
      path: '/tags/user-tags-direct';
      operationId: 'getUserTagsDirect';
      variables: GetUserTagsDirectVariables;
    }
  | {
      path: '/second-brain/chats';
      operationId: 'getSecondBrainChats';
      variables: GetSecondBrainChatsVariables;
    }
  | {
      path: '/second-brain/chats/{chatId}';
      operationId: 'getSecondBrainChat';
      variables: GetSecondBrainChatVariables;
    }
  | {
      path: '/organizations/';
      operationId: 'getOrganizations';
      variables: GetOrganizationsVariables;
    }
  | {
      path: '/organizations/{organizationId}';
      operationId: 'getOrganization';
      variables: GetOrganizationVariables;
    }
  | {
      path: '/organizations/{organizationId}/notes/{noteId}';
      operationId: 'getOrganizationNote';
      variables: GetOrganizationNoteVariables;
    };
